export default defineAppConfig({
    ui: {
        primary: 'brand',
        gray: 'slate',
        notifications: {
            position: 'bottom-2 inset-x-0 mx-auto',
        },
        button: {
            default: {
                loadingIcon: 'i-ph-circle-notch-bold',
            },
            icon: {
                size: {
                    sm: 'h-4 w-4',
                },
            },
        },
        badge: {
            color: {
                gray: {
                    subtle: 'bg-gray-50 border border-gray-300'
                }
            }
        },
        input: {
            icon: {
                size: {
                    sm: 'h-4 w-4',
                },
            },
        },
        table: {
            tbody: 'divide-dashed divide-gray-300',
            th: {
                padding: 'first:pl-6 py-3',
                font: 'font-medium',
                size: 'text-[13px] uppercase',
                color: 'text-gray-600 dark:text-white',
            },
            td: {
                padding: 'first:pl-6 py-2',
                size: 'text-base',
            },
            loadingState: {
                icon: 'h-5 w-5 text-gray-400',
            },
            emptyState: {
                icon: 'text-gray-400 mb-1',
                label: 'text-gray-400',
            },
        },
        dropdown: {
            item: {
                icon: {
                    base: 'w-4 h-4',
                },
            },
        },
        slideover: {
            wrapper: 'lg:inset-3',
            base: 'lg:rounded-r-lg overflow-hidden',
            overlay: {
                background: 'bg-gray-200/40 dark:bg-gray-800/40',
            },
        },
        card: {
            ring: '',
            shadow: '',
            rounded: '',
            base: 'h-full flex flex-col',
            body: { base: 'flex-1 overflow-auto' },
            divide: 'divide-y divide-gray-200',
        },
    },
})
